var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 17.5H12.9688C12.7109 17.5 12.5 17.2891 12.5 17.0312V15.4688C12.5 15.2109 12.7109 15 12.9688 15H16.25C16.9414 15 17.5 14.4414 17.5 13.75V6.25C17.5 5.55859 16.9414 5 16.25 5H12.9688C12.7109 5 12.5 4.78906 12.5 4.53125V2.96875C12.5 2.71094 12.7109 2.5 12.9688 2.5H16.25C18.3203 2.5 20 4.17969 20 6.25V13.75C20 15.8203 18.3203 17.5 16.25 17.5ZM14.4141 9.64844L7.85156 3.08594C7.26562 2.5 6.25 2.91016 6.25 3.75V7.5H0.9375C0.417969 7.5 0 7.91797 0 8.4375V12.1875C0 12.707 0.417969 13.125 0.9375 13.125H6.25V16.875C6.25 17.7148 7.26562 18.125 7.85156 17.5391L14.4141 10.9766C14.7773 10.6094 14.7773 10.0156 14.4141 9.64844Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.ecac3406.svg";
export { ForwardRef as ReactComponent };